<template>
  <div id="survey-permission">
    <b-form>
      <b-card no-body class="p-2 px-5 container-card mb-1">
        <b-row>
          <b-col lg="7" md="8" class="pt-2">
            <setting-permission
              :class="!permissionData.isEdit ? 'bypass' : ''"
              :formData="permissionData"
              :tagOption="tagOption"
              @onSelectTagVisibility="onSelectTagVisibility"
              @onInputDuplicateTag="onInputDuplicateTag"
            />
          </b-col>
        </b-row>
      </b-card>
      <b-card no-body class="p-2 px-5 container-card mb-1">
        <b-row>
          <b-col cols="8">
            <div class="mb-2 custom-ml">
              <div class="mb-1 permission-header">
                กำหนดจำนวนผู้ที่สามารถเล่นเกมนี้ได้
              </div>
              <div>
                <b-row>
                  <b-col cols="12">
                    <div class="d-flex">
                      <b-form-checkbox
                        v-model="permissionData.limitPlayer"
                        class="mr-0 custom-control-success"
                        name="is-rtl"
                        :value="false"
                        :unchecked-value="true"
                        switch
                        inline
                        :disabled="!permissionData.isEdit"
                        @input="onChangePoint(permissionData.limitPlayer)"
                      />
                      <div class="ml-2">
                        <div class="text-black font-medium-3">
                          <b>ไม่จำกัดจำนวนผู้ตอบแบบสำรวจ</b>
                        </div>
                        <div>
                          เปิดให้ผู้ตอบแบบสำรวจสามารถใช้งานได้ไม่จำกัดจำนวน
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12">
                    <b-row class="pl-1 mt-1">
                      <b-form-checkbox
                        v-model="permissionData.limitPlayer"
                        class="mr-0 custom-control-success"
                        name="is-rtl"
                        :value="true"
                        switch
                        inline
                        :disabled="!permissionData.isEdit"
                      />
                      <b-col class="ml-2">
                        <b-row
                          class="text-black font-medium-3 font-medium-3 d-flex justify-content-between"
                          ><div><b>จำกัดจำนวนผู้ตอบแบบสำรวจ</b></div>
                          <div
                            class="d-flex align-items-center justify-content-end"
                          >
                            <input-spin-quiz
                              :isDisabled="
                                !permissionData.limitPlayer ||
                                !permissionData.isEdit
                              "
                              :numValue="permissionData.numberPlayer"
                              :isInputDisabled="false"
                              @update-number="onUpdateLimit"
                            />
                          </div>
                        </b-row>
                        <b-row class="text-black font-medium-3"
                          >เปิดให้ผู้ตอบแบบสามารถใช้งานได้จำกัดจำนวน</b-row
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import SettingPermission from "./SettingPermission.vue";
import usePremissionTab from "../hooks/usePermissionTab";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";
export default {
  props: {
    isEdit: { type: Boolean, default: false },
  },
  components: { SettingPermission, InputSpinQuiz },
  setup(props) {
    const {
      permissionData,
      tagOption,
      onSelectTagVisibility,
      onInputDuplicateTag,
      payload,
      onUpdateLimit,
      onChangePoint,
    } = usePremissionTab(props);

    return {
      permissionData,
      tagOption,
      onSelectTagVisibility,
      onInputDuplicateTag,
      payload,
      onUpdateLimit,
      onChangePoint,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/permission.css";
@import "~@/assets/css/pages/survey/permission.css";
@import "~@/assets/css/override-styles/tag-dropdown.css";
</style>>